// IE 2026 10 31 / ODOO-5800 (заказ Игоря: «Хронологія змін» — на оси X одни числа дней, без месяца и года): полосы год / месяц / неделя над осью дат
// AttrChart строил только при data_schedule (календарь отчёта REPORT2); у списка над SQL-источником (widget-list над DS, например DS-audit-timeline)
// расписания нет — частота «Кілька» (G) ничем не раскрывалась и группы не строились. Теперь без расписания: шаг ряда — по формату дат самих строк
// (yyyy-MM-dd → дни, yyyy-MM → месяцы), полосы — по date_Year / date_Month / date_Week, которые load_data считает из даты каждой строки,
// подпись даты в подсказке — из тех же полей. Флаг fe.ux.chartDateGroupsNoSchedule (дефолт ВКЛ, §8). Юнит — tests/unit/chartDateGroups.test.mjs
export const CHART_DATE_GROUPS_FLAG = 'fe.ux.chartDateGroupsNoSchedule'

export function chartDateGroups_on(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CHART_DATE_GROUPS_FLAG, true) !== false : true } catch (e) { return true }
}

// шаг ряда без расписания: 'M' для месячных дат (yyyy-MM), иначе 'D'; freq не G, есть расписание или нет дат — как было (null = не менять)
export function chartDateGroups_freq({ freq, hasSchedule, formatX, rows, on = true } = {}) {
    if (!on || freq !== 'G' || hasSchedule) return null
    if (!Array.isArray(rows) || !rows.some(r => r && r.date)) return null
    return formatX === 'yyyy-MM' ? 'M' : 'D'
}

// строки годятся для полос без расписания: у каждой строки с датой разобран год (иначе wijmo завёл бы группу «undefined»), и такая строка есть
export function chartDateGroups_rowsOk(rows, on = true) {
    if (!on || !Array.isArray(rows) || !rows.length) return false
    let dated = 0
    for (const r of rows) { if (r && r.date) { if (!r.date_Year) return false; dated++ } }
    return dated > 0
}

// подпись даты в подсказке точки без расписания: по шагу ряда; нет разобранного года — null (прежний текст)
export function chartDateGroups_tooltip(item, freq) {
    if (!item || !item.date_Year) return null
    if (freq === 'M' || item.date_Bucket) return `${item.date_Year} ${item.date_Bucket || item.date_Month}`   // месячный бакет на оси дней — как месяц
    if (freq === 'A') return `${item.date_Year}`
    return `${item.date_Year} ${item.date_Month} ${item.date_Day}  ${item.date_Week}`
}

// IE 2026 11 02 / ODOO-347310 (заказ Андрея: на оси месяцы повторяются): ряд со смешанной сеткой (факт месяцами, начало плана днями, дальше снова месяцы) — ось дней.
// Месячный бакет — строка 1-го числа, у которой сосед (предыдущая или следующая строка) — тоже 1-е число другого месяца: полоса месячных строк.
// Живой ряд 585_001 / 0dB_001 (demo7): 2026-04-01 … 2026-10-01, затем дни с 2026-10-19 — у 2026-10-01 в октябре есть и дневные строки,
// поэтому счёт строк на месяц (первая редакция) оставлял ему подпись «1»; 1-е число внутри дневной полосы (сосед — день) — обычный день.
// Результат — Set ИНДЕКСОВ таких строк
export function chartDateGroups_monthBuckets(rows) {
    const d = (rows || []).map(r => (r && r.date ? String(r.date).slice(0, 10) : ''))
    const first = (s) => s.length === 10 && s.slice(8, 10) === '01'
    const otherMonth = (a, b) => first(a) && first(b) && a.slice(0, 7) !== b.slice(0, 7)
    const out = new Set()
    for (let i = 0; i < d.length; i++) {
        if (first(d[i]) && (otherMonth(d[i - 1] || '', d[i]) || otherMonth(d[i], d[i + 1] || ''))) out.add(i)
    }
    return out
}
// Месячный бакет на оси дней: подпись деления — имя месяца (date_Bucket, его же берёт подсказка), полосы месяца и недели — без подписи.
// Имя группы месяца должно остаться УНИКАЛЬНЫМ (k-й бакет — k+1 невидимых U+200B): CollectionView сливает равные значения в одну группу
// и переставляет строки — линия пошла бы зигзагом. Такую пустую группу ось не рисует (chartDateGroups_bandLabels)
export function chartDateGroups_bucketRow(row, k) {
    row.date_Bucket = row.date_Month
    row.date_Month = '\u200b'.repeat((k | 0) + 1)
    row.date_Week = ''
    return row.date_Bucket
}
// подписи полосы групп оси (wijmo _AxisGroup.labels) без пустых: ни текста (он резался бы до буквы), ни скобки «└─┘» над ней
export function chartDateGroups_bandLabels(labels) {
    return (labels || []).filter(l => l && !/^[\s\u200b]*$/.test(String(l.label ?? '')))
}
